import {
  GavelOutlined, AddCircleOutline, FormatListBulleted, SettingsOutlined,
  DescriptionOutlined, PeopleAltOutlined, PersonOutline, AccountTreeOutlined,
  CategoryOutlined, ScheduleOutlined, ExtensionOutlined, MailOutline,
  SendAndArchiveOutlined, MoveToInboxOutlined, ViewListOutlined,
  NewspaperOutlined, BookmarkBorderOutlined, WorkspacePremiumOutlined, InsightsOutlined,
  HomeOutlined,
  // AutoAwesomeOutlined, TuneOutlined,
} from "@mui/icons-material";

// Fuente única de la navegación: la usan el Sidebar, las migas de pan y el buscador (Ctrl+K).
// Tipos de entrada:
//   { tipo: "seccion", label }
//   { tipo: "item", ruta, label, icon, servicio? }   `servicio`: módulo contratado requerido (rol Usuario)
//   { tipo: "grupo", id, label, icon, hijos: [...] }
const item = (ruta, label, icon, extra = {}) => ({ tipo: "item", ruta, label, icon, ...extra });
const grupo = (id, label, icon, hijos) => ({ tipo: "grupo", id, label, icon, hijos });
const seccion = (label) => ({ tipo: "seccion", label });

export const MENU_POR_ROL = {
  Administrador: [
    item("/home", "Inicio", HomeOutlined),
    seccion("Reportes"),
    item("/dashboard-impacto", "Dashboard de impacto", InsightsOutlined),
    seccion("Normativas"),
    grupo("normativas", "Gestión de normativas", GavelOutlined, [
      item("/nueva-normativa", "Agregar normativa", AddCircleOutline),
      item("/gestor-normativa", "Gestor de normativas", FormatListBulleted),
      item("/envio-correo-normativa", "Envío de correos manual", MailOutline),
      item("/newsletter", "Newsletter", NewspaperOutlined),
    ]),
    grupo("bandejaNormativa", "Scraper normativas", MoveToInboxOutlined, [
      item("/bandeja-normativas", "Bandeja de normativas", ViewListOutlined),
      item("/horario-envio-scraper", "Horario envío scraper", ScheduleOutlined),
    ]),
    // seccion("Herramientas"),
    // item("/usuario/analizador-norma", "Analizar norma", AutoAwesomeOutlined),
    seccion("Administración"),
    grupo("admin", "Administración general", SettingsOutlined, [
      grupo("clientes", "Clientes", PeopleAltOutlined, [
        item("/cliente/correos", "Correos", MailOutline),
        item("/cliente/configuracion-correo", "Configurar envío correos", SettingsOutlined),
        item("/cliente/gestor-clientes", "Gestor de clientes", PersonOutline),
        item("/cliente/gestor-organismos", "Gestionar organismos", AccountTreeOutlined),
        item("/cliente/gestor-rubros", "Gestionar rubros", CategoryOutlined),
        item("/cliente/gestor-modulos", "Módulos", ExtensionOutlined),
        item("/cliente/horario-clientes", "Horario clientes", ScheduleOutlined),
      ]),
      item("/clasificacion-documento", "Clasificación documento", DescriptionOutlined),
      item("/enlace-congreso", "Enlace de congreso", DescriptionOutlined),
      item("/estado-tramitacion", "Estado de tramitación", DescriptionOutlined),
      item("/organismo-emisor", "Organismo emisor", AccountTreeOutlined),
      item("/rubros", "Rubros", CategoryOutlined),
      item("/tipo-documento", "Tipo de documento", DescriptionOutlined),
      item("/paises", "Países", DescriptionOutlined),
      item("/usuarios", "Usuarios", PeopleAltOutlined),
      item("/logs", "Gestor de logs", DescriptionOutlined),
      // item("/cliente/cupo-analizador", "Cupo del analizador", TuneOutlined),
    ]),
  ],

  Suscriptor: [
    seccion("Normativas"),
    item("/suscriptor/bandeja", "Mis normativas", GavelOutlined),
    seccion("Cuenta"),
    item("/suscriptor/mi-suscripcion", "Mi suscripción", WorkspacePremiumOutlined),
  ],

  Usuario: [
    item("/home", "Inicio", HomeOutlined),
    seccion("Normativas"),
    item("/dashboard-impacto", "Dashboard de impacto", InsightsOutlined, { servicio: "Impacto" }),
    item("/usuario/gestor-normativa", "Normativas históricas", GavelOutlined),
    item("/usuario/normativas-guardadas", "Guardados", BookmarkBorderOutlined),
    // seccion("Herramientas"),
    // item("/usuario/analizador-norma", "Analizar norma", AutoAwesomeOutlined),
    seccion("Integraciones"),
    item("/usuario/integracion-grc-normativas", "Enviar a AustranetGRC", SendAndArchiveOutlined, {
      servicio: "Integracion AustranetGRC",
    }),
  ],
};

// Ruta principal de listado de normativas por rol (destino de la búsqueda global)
export const RUTA_BUSQUEDA_NORMATIVAS = {
  Administrador: "/gestor-normativa",
  Usuario: "/usuario/gestor-normativa",
};

// Menú del rol, sin los items de módulos no contratados ni secciones que queden vacías.
// `puedeVer(servicio)` decide si se muestra un item que requiere módulo.
export const getMenu = (rol, puedeVer = () => true) => {
  const filtrar = (entradas) => {
    const visibles = entradas
      .filter((e) => e.tipo !== "item" || !e.servicio || puedeVer(e.servicio))
      .map((e) => (e.tipo === "grupo" ? { ...e, hijos: filtrar(e.hijos) } : e))
      .filter((e) => e.tipo !== "grupo" || e.hijos.length > 0);
    // Quita secciones sin items debajo
    return visibles.filter((e, i) => {
      if (e.tipo !== "seccion") return true;
      const siguiente = visibles[i + 1];
      return siguiente && siguiente.tipo !== "seccion";
    });
  };
  return filtrar(MENU_POR_ROL[rol] || MENU_POR_ROL.Usuario);
};

// Lista plana de items navegables con su ruta de grupos (para buscador y migas)
export const aplanarMenu = (entradas, grupos = []) =>
  entradas.flatMap((e) => {
    if (e.tipo === "item") return [{ ...e, grupos }];
    if (e.tipo === "grupo") return aplanarMenu(e.hijos, [...grupos, e]);
    return [];
  });

// Ids de los grupos que contienen la ruta (para expandirlos en el Sidebar)
export const gruposConRuta = (entradas, ruta) => {
  const item = aplanarMenu(entradas).find((i) => i.ruta === ruta);
  return item ? item.grupos.map((g) => g.id) : [];
};
